export const CFT = {
  ACCOUNTANT_HUB: 'accountant-hub',
  ACCOUNTING_ONBOARDING: 'accounting-onboarding',
  APP_SYSTEMS: 'app-systems',
  CASH_FLOW_MANAGEMENT: 'cash-flow-management',
  CL_ACTIVATION: 'cl-activation',
  CL_ACCOUNT_MANAGEMENT: 'cl-account-management',
  CONNECT: 'connect',
  DUE_DILIGENCE: 'due-diligence',
  FINANCING: 'financing',
  SPEND_MANAGEMENT: 'spend-management',
  CARDS_ISSUING: 'cards-issuing',
  CARDS_ACCEPTANCE: 'cards-acceptance',
  ACCOUNTS_PAYABLE: 'accounts-payable',
  ACCOUNTS_RECEIVABLE: 'accounts-receivable',
  PRICING: 'pricing',
  AI_LAB: 'ai-lab',
  TRANSFERS: 'transfers',
  PRE_ACCOUNTING: 'pre-accounting',
  REGISTRATION: 'registration',
} as const;

type CFTKey = keyof typeof CFT;
export type CFTValue = (typeof CFT)[CFTKey];

export const PIPE = {
  ACCOUNTANT_HUB: {},
  ACCOUNTING_ONBOARDING: {},
  APP_SYSTEMS: {},
  CASH_FLOW_MANAGEMENT: {},
  CL_ACTIVATION: {},
  CL_ACCOUNT_MANAGEMENT: {},
  CONNECT: {},
  DUE_DILIGENCE: {
    INITIAL: 'initial',
    ONGOING: 'ongoing',
  },
  FINANCING: {},
  SPEND_MANAGEMENT: {},
  CARDS_ISSUING: {},
  CARDS_ACCEPTANCE: {},
  ACCOUNTS_PAYABLE: {},
  ACCOUNTS_RECEIVABLE: {},
  PRICING: {},
  AI_LAB: {},
  TRANSFERS: {},
  PRE_ACCOUNTING: {},
  REGISTRATION: {},
} as const satisfies Record<CFTKey, Record<string, string>>;

export type CFTPipeValue = {
  [K in CFTKey]: (typeof PIPE)[K][keyof (typeof PIPE)[K]];
}[CFTKey];
